export default "__VITE_ASSET__4cc76b78__"